import { render } from "./CarouselBackground.vue?vue&type=template&id=54e02b94&ts=true"
import script from "./CarouselBackground.vue?vue&type=script&lang=ts"
export * from "./CarouselBackground.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src903112286/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__